import { useTranslation } from 'react-i18next'
import { DocumentFile } from '../../api/documents/types'
import DocumentForm from './DocumentForm'

interface DocumentEditPanelProps {
    documentData: DocumentFile
    contactType?: string
    parentId?: string | number
    sidebarClose: () => void
}

const DocumentEditPanel = ({ documentData, contactType, parentId, sidebarClose }: DocumentEditPanelProps) => {
    const { t } = useTranslation()

    return (
        <div className="file-manager-detail-content bg-white border-start p-3 show" style={{ width: '500px' }}>
            <div className="d-flex align-items-center pb-3 border-bottom mb-3">
                <h5 className="flex-grow-1 fw-light mb-0">
                    {t('form.documentFormSidebar.title.edit')} ID: {documentData.internalAppId}
                </h5>
                <button
                    type="button"
                    className="btn btn-dark btn-icon btn-sm fs-16"
                    data-testid="document-sidebar-close-btn"
                    onClick={() => sidebarClose()}
                >
                    <i className="mdi mdi-close align-bottom"></i>
                </button>
            </div>

            <DocumentForm mode="edit" documentData={documentData} contactType={contactType} parentId={parentId} onSaved={sidebarClose} />
        </div>
    )
}

export default DocumentEditPanel
